
import {Component, Prop, Vue, Watch} from "vue-property-decorator";
import {MdbsCore} from "@/api/tsclient";
import {deepCopy} from "@/auxillary";
import StudyInstituteUpdateDto = MdbsCore.StudyInstituteUpdateDto;
import {studyInstitutesModule, usersModule} from "@/store";
import IStudyInstituteUpdateDto = MdbsCore.IStudyInstituteUpdateDto;
import ShortUserDto = MdbsCore.ShortUserDto;
import {rules} from "@/auxillary/rules";
import {flatObjectEqual} from "@/auxillary/flat-object-equal";

@Component({})
export default class StudyInstituteEditDialog extends Vue {
  @Prop({required: true})
  institute!: IStudyInstituteUpdateDto;

  currentInstitute: IStudyInstituteUpdateDto = new StudyInstituteUpdateDto();
  country: any = null;
  countries = [
    {
      "displayName": "Deutschland",
      "value": "germany"
    },
    {
      "displayName": "Österreich",
      "value": "austria"
    }
  ]
  saving = false;
  valid = false;
  instituteChanged = false;

  rules: any = rules;

  get allUsers() {
    return usersModule.users;
  }

  get usersLoading() {
    return usersModule.isLoading;
  }

  get hasChanges () {
    return this.instituteChanged || this.currentInstitute.additionalInfo?.country != this.country;
  }

  @Watch('currentInstitute', {deep: true})
  dataChanged() {
    this.instituteChanged = !flatObjectEqual(this.currentInstitute, this.institute, true);
  }

  @Watch('institute', {immediate: true})
  async onInstituteChange(institute: IStudyInstituteUpdateDto | null) {
    this.currentInstitute = deepCopy(institute) ?? new StudyInstituteUpdateDto();
    this.country =  this.currentInstitute.additionalInfo?.country;

    if (institute != null) {
      await usersModule.loadAll();
    }
  }

  getUserName(user: ShortUserDto) {
    return user.userName + " - " + user.displayName
  }

  async save() {
    try {
      this.saving = true;
      if (this.currentInstitute.maxPatientsCount !== undefined) {
        this.currentInstitute.maxPatientsCount = Number.parseInt(this.currentInstitute.maxPatientsCount?.toString());
      }

      if (this.currentInstitute.additionalInfo == undefined)
        this.currentInstitute.additionalInfo = {};
      this.currentInstitute.additionalInfo.country = this.country ?? "";

      await studyInstitutesModule.updateStudyInstitute(this.currentInstitute);

      this.$emit('save');
    } finally {
      this.saving = false;
    }
  }

  async cancel() {
    this.$emit('cancel');
  }
}
